<div class="error-badge-container">
  <!-- Badge top -->
  <div class="flex-container-top">
    <div class="flex-container-left-div">
      <!-- Icon container   -->
      <div class="icon-container">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <!-- Error title container -->
      <div class="flex-container-error-header">
        <span class="error-name">{{ errorHeader }}</span>
        <span class="view-error-detail"
          >Ver detalle del error
          <button
            *ngIf="!displayErrorMessage"
            (click)="this.displayErrorMessage = !this.displayErrorMessage"
          >
            <i class="fas fa-chevron-down"></i>
          </button>
          <button
            *ngIf="displayErrorMessage"
            (click)="this.displayErrorMessage = !this.displayErrorMessage"
          >
            <i class="fas fa-chevron-up"></i>
          </button>
        </span>
      </div>
    </div>

    <div *ngIf="allowReprocessing" class="flex-container-reprocess">
      <div class="vertical-line"></div>
      <button (click)="onClickReprocess()">
        <span class="fa fa-sync-alt"> </span>
        Reprocesar
      </button>
    </div>
  </div>

  <!-- Badge Error message -->
  <div *ngIf="displayErrorMessage" class="flex-container-error-body">
    <span class="subtitle">{{ errorBody }}</span>
  </div>
</div>
